import {ChangeDetectorRef, Component,Output, OnDestroy,EventEmitter, OnInit,Input,OnChanges,ChangeDetectionStrategy,ApplicationRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {TranslateService} from "../../../../node_modules/ng2-translate/src/translate.service";
import {CompanyService} from "../../services/company-service/company-service";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CategoryService} from "../../services/category/category.service";
import {IntakeFormVM} from "../../models/IntakeForm.model";
import {IntakeFieldVM} from "../../models/IntakeForm.model";
import {AlertService} from "../../services/alert/alert.service";


@Component({
  selector: 'rw-intake-form',
  template: require('./intake-form.component.html'),
  styles: [require('./intake-form.style.css')],
  providers: [CategoryService]

})

export class IntakeFormComponent implements OnDestroy, OnInit,OnChanges {
  @Input() intakeForm:IntakeFormVM = new IntakeFormVM();
  @Output() intakeFormChange = new EventEmitter();
  requiredFieldExist: boolean = false;

  constructor(private ref:ChangeDetectorRef,
              public route:ActivatedRoute,
              public router:Router,
              public translate:TranslateService,
              private categoryService:CategoryService, private alertService:AlertService) {



  }

  collectFormData() {
    let parent=this;
    let isFormValid=true;
   this.intakeForm.fields.forEach(function(f){

    let isValid=parent.checkIsFormValid(f);
     if(!isValid)
     isFormValid=false;


   })

    this.intakeFormChange.emit(this.intakeForm);
    return isFormValid;
  }

  checkIsFormValid(field:IntakeFieldVM)
  {
    if(!this.checkRequired(field))
      return false;
    if(!this.checkInputIsValid(field))
      return false;

    return true;

  }

  checkRequired(field:IntakeFieldVM)
  {
    if(field.required && !this.isFieldHidden(field))
    {
      if(field.value && field.value.toString().trim().length>0)
      return true;
      else
      {
       this.alertService.showErrorMessage("لطفا " + field.label+" را وارد کنید ");
        return false;
      }
    }else
    {
      return true;
    }
  }

  checkInputIsValid(field:IntakeFieldVM)
  {
    if(!field.value)
      return true;

    if(field.fieldType =='Number')
    {
      if(!this.isNumeric(field.value))
      {
        this.alertService.showErrorMessage(  field.label+" به درستی وارد نشده است ");
        return false;
      }
    }

    if(field.extraSettingObject )
    {
      //check input length
      if(field.extraSettingObject.inputLength )
      {
        if(field.value.toString().length != field.extraSettingObject.inputLength)
        {
          this.alertService.showErrorMessage(  field.label+" باید "+field.extraSettingObject.inputLength +" رقم باشد.");
          return false;
        }
      }
      if(field.extraSettingObject.inputStartWith )
      {
        if(!field.value.toString().startsWith(field.extraSettingObject.inputStartWith))
        {
          this.alertService.showErrorMessage(  field.label+" باید با "+field.extraSettingObject.inputStartWith +" شروع شود.");
          return false;
        }
      }
    }

    return true;
  }

  isNumeric(value) {
    return /^\d+$/.test(value);
  }

  ngOnDestroy():void {


  }

  ngOnInit():void {
    this.intakeForm.fields.forEach(element =>{
      if (element.required === true){
        this.requiredFieldExist = true;
      }
    })


  }

  ngOnChanges(changes):void {


  }

  findConditionsParentField(childFiled:IntakeFieldVM)
  {
    let parentField =  this.intakeForm.fields.filter((f)=> {
      return f.name == childFiled.conditionalParentFieldName
    });

    if(parentField)
      return parentField[0];
    else
      return null;
  }

  showConditionalField(intakeField:IntakeFieldVM)
  {
    if(!intakeField.isConditional)
      return true;
    let parentField  = this.findConditionsParentField(intakeField);
    if(parentField && parentField.value)
    {
      if(intakeField.conditionalParentValues.indexOf(parentField.value.toString())>-1 )
      {
        return true;
      }
    }

    return false;

  }


  isFieldHidden(field:IntakeFieldVM)
  {
    return (!this.showConditionalField(field));
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/intake-form/intake-form.component.ts